export const formatTime = (secs) => {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
};

export const parseError = (errorMsg) => {
    try { const parsed = JSON.parse(errorMsg.split(']: ')[1]); return parsed.error || "Onbekende fout opgetreden"; } 
    catch (e) { if (errorMsg.includes(']: ')) return errorMsg.split(']: ')[1]; return errorMsg; } 
};
